import {AfterViewInit, Component, ViewChild, ViewContainerRef} from "@angular/core";
import {ICellEditorAngularComp} from "ag-grid-angular";

@Component({
    selector: 'ag-numeric-cell',
    template: `<input #input (keydown)="onKeyDown($event)" [(ngModel)]="value" style="width: 100%; height:100%;">`
})
export class AgNumericEditor implements ICellEditorAngularComp, AfterViewInit {
    private params: any;
    public value: number;
    private cancelBeforeStart: boolean = false;
    
    @ViewChild('input', {read: ViewContainerRef}) public input;


    agInit(params: any): void {
        this.params = params;
        // only start edit if key pressed is a number, not a letter
        // this.cancelBeforeStart = params.charPress && ('1234567890.'.indexOf(params.charPress) < 0);
    }

    getValue(): any {
        if (!this.value) return null;
        let value: number = Number(String(this.value));
        return (Number.isNaN(value) ? null: value);
    }

    isCancelBeforeStart(): boolean {
        return this.cancelBeforeStart;
    }

    // will reject the number if it greater than 100,000,000
    // not very practical, but demonstrates the method.
    isCancelAfterEnd(): boolean {
        return this.value > 100000000;
    };

    onKeyDown(event: KeyboardEvent): void {
        if (event.keyCode == 13) {
            this.params.api.clearRangeSelection();
            this.params.api.setFocusedCell(this.params.rowIndex + 1, this.params.column);
        }
        
        if (event.keyCode == 37 //ArrowLeft
            || event.keyCode == 39 //ArrowRight
            || event.keyCode == 8 //Backspace
            || event.keyCode == 46 //Delete
            || event.keyCode == 36 //Home
            || event.keyCode == 35 //End
            ) {
            event.stopPropagation();
        } else if (!this.isKeyPressedNumeric(event)) {
            if (event.preventDefault) event.preventDefault();
            return;
        }
    }

    // dont use afterGuiAttached for post gui events - hook into ngAfterViewInit instead for this
    ngAfterViewInit() {
        setTimeout(() => {
            this.input.element.nativeElement.focus();
            if (this.params.charPress && this.isCharNumeric(this.params.charPress)) this.value = this.params.charPress;
            else this.value = this.params.value;
        })
    }

    private getCharCodeFromEvent(event): any {
        event = event || window.event;
        return (typeof event.which == "undefined") ? event.keyCode : event.which;
    }

    private isCharNumeric(charStr): boolean {
        return !!/\d/.test(charStr) || charStr == '.';
    }

    private isKeyPressedNumeric(event): boolean {
        const charCode = this.getCharCodeFromEvent(event);
        if (charCode == 8) return true; //backspace;

        let charStr = event.key ? event.key : String.fromCharCode(charCode);
        if (event.keyCode == 110) charStr = '.';
        
        return this.isCharNumeric(charStr);
    }
}


// WEBPACK FOOTER //
// ./src/app/components/ag-grid/editor/ag-numeric.editor.ts